<ion-header>
  <ion-toolbar>
    <ion-title class="tb">
      <span>
        {{ 'SPORT_TYPE_JGJ' | translate }}
      </span>
      <span style="font-size: 1.2rem; color: grey; font-weight: 400;">
       {{'LEAGUE' | translate}}
      </span>
    </ion-title>

  </ion-toolbar>
</ion-header>
<ion-content fullscreen="true">
  <ion-list>

    <ion-item class="combo-btn">
      <ion-label class="plus-btn" (click)="onAddEvent()">
        +
      </ion-label>
      <ion-select class="pick" [(ngModel)]="plan.eventId" [placeholder]="events[0]?.name">
        <ion-select-option *ngFor="let event of events" [value]="event.id">
          {{ event.name }}
        </ion-select-option>
      </ion-select>
    </ion-item>

    <ion-item class="empty-gap">
      <ion-label></ion-label>
    </ion-item>

    <ion-item>
      <ion-label>
        Name
      </ion-label>
      <ion-input [(ngModel)]="plan.name" class="text-start">
      </ion-input>
    </ion-item>
    
    <ion-item>
      <ion-label>
        Sportart:
      </ion-label>
      <ion-select [(ngModel)]="plan.sporttype" [placeholder]="getSportName()" multiple="false">
        <ion-select-option [value]="0">{{ 'american_football_1' | translate }}</ion-select-option>
        <ion-select-option [value]="1">{{ 'american_football_2' | translate }}</ion-select-option>
        <ion-select-option [value]="2">{{ 'baseball' | translate }}</ion-select-option>
        <ion-select-option [value]="3">{{ 'basketball' | translate }}</ion-select-option>
        <ion-select-option [value]="4">{{ 'football' | translate }}</ion-select-option>
        <ion-select-option [value]="5">{{ 'handball' | translate }}</ion-select-option>
        <ion-select-option [value]="6">{{ 'hokey' | translate }}</ion-select-option>
        <ion-select-option [value]="7">{{ 'indoor_football' | translate }}</ion-select-option>
        <ion-select-option [value]="8">{{ 'tennis_1' | translate }}</ion-select-option>
        <ion-select-option [value]="9">{{ 'tennis_2' | translate }}</ion-select-option>
        <ion-select-option [value]="10">{{ 'tennis_3' | translate }}</ion-select-option>
        <ion-select-option [value]="11">{{ 'volleyball' | translate }}</ion-select-option>
        <ion-select-option [value]="12">{{ 'water_polo' | translate }}</ion-select-option>
      </ion-select>
    </ion-item>


    <ion-item class="no-btm-border">
      <ion-label>
        Mannschaften
      </ion-label>
      <ion-input [disabled]="true" value="{{ plan.teamNum }}">
      </ion-input>
    </ion-item>

    <ion-item>
      <ion-range min="2" max="60" step="2" [(ngModel)]="plan.teamNum" color="primary" (ionChange)="onTeamNumChange()">
        <ion-label slot="start">2</ion-label>
        <ion-label slot="end">60</ion-label>
      </ion-range>
    </ion-item>

    <ion-item>
      <ion-label>
        Spielrunden
      </ion-label>
      <ion-select [(ngModel)]="plan.rounds" multiple="false">
        <ion-select-option [value]="1">Hinrunde</ion-select-option>
        <ion-select-option [value]="2">Hin- & Rückrunde</ion-select-option>
        <ion-select-option [value]="3">3 Runden</ion-select-option>
        <ion-select-option [value]="4">4 Runden</ion-select-option>
      </ion-select>
    </ion-item>
  </ion-list>

  <ion-button expand="block" fill="outline" (click)="save()">
    <div class="btn-inner">{{ plan.games }} {{ 'GLOBAL_GAMES' | translate }}</div>
    <div>{{ 'GLOBAL_CREATE' | translate }}</div>
  </ion-button>
</ion-content>